import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import DataTable from 'components/organisms/DataTable'
import SearchField from 'components/atoms/SearchField'
import PaginationControl from 'components/organisms/PaginationControl'

import { groupViewerTableColumns } from './'

export const styles = theme => ({
  root: {
    minHeight: 500,
    padding: `${theme.spacing(1)}px 0`,
  },
  table: {
    margin: `${theme.spacing(6)}px 0`,
  },
})

const ManageGroupViewers = ({
  classes,
  viewers,
  filters,
  tableLoading,
  onPageChange,
  onSearchChange,
  onTableSortClick,
  onTableSelectableClick,
}) => (
  <div className={classes.root}>
    <Grid container justify="space-between" alignItems="center">
      <Typography variant="h1">All contributors</Typography>
      <SearchField onChange={onSearchChange} />
    </Grid>
    <DataTable
      key="Manage group contributors table"
      dataProvider={viewers}
      className={classes.table}
      tableLoading={tableLoading}
      onSortClick={onTableSortClick}
      columns={groupViewerTableColumns}
      onSelectableClick={onTableSelectableClick}
      emptyStateTitle="This group has no contributors"
      emptyStateDescription="Add contributors to this group so they can start placing traps!"
    />
    <PaginationControl
      pagination={filters.pagination}
      onPageChange={onPageChange}
    />
  </div>
)

ManageGroupViewers.propTypes = {
  viewers: PropTypes.object,
  classes: PropTypes.object,
  filters: PropTypes.object,
  tableLoading: PropTypes.bool,
  onPageChange: PropTypes.func,
  onSearchChange: PropTypes.func,
  onTableSortClick: PropTypes.func,
  onTableSelectableClick: PropTypes.func,
}

export default withStyles(styles)(ManageGroupViewers)



// WEBPACK FOOTER //
// ./src/containers/groups/ManageGroupViewers/ManageGroupViewers.js